import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { catchError, map, mergeMap, retry } from "rxjs/operators";
import { urlConfig } from "../../../../config/url.config";
import { CMSStep } from "../../model/cms-model";
import { StorageModule } from "../../utils/storage.module";
import { MonitoringService } from "../../../../app/shared/services/monitoring.service";

@Injectable({
    providedIn: "root",
})
export class CmsService {
    private shallowId = "onboarding-link";
    private url: string;
    private httpOptions = () => {
        let options = {};
        let staging: any = urlConfig.cmsHeaderStg;

        if (staging == "true") {
            options = {
                ...options,
                headers: new HttpHeaders({
                    "X-Staging": "x",
                }),
            };
        }

        options = {
            ...options,
            params: new HttpParams().set("gw-app-key", urlConfig.zup_app_key),
        };

        return options;
    };

    constructor(
        @Inject(HttpClient) public https: HttpClient,
        @Inject(StorageModule) public storage: StorageModule,
    ) {
        this.url = urlConfig.url_hub_cms;
    }

    public getAndSetStoragePages(cmsPages?) {
        if (cmsPages) return this.storage.setCmsPages(JSON.stringify(cmsPages));
        return JSON.parse(this.storage.getCmsPages());
    }

    public haveInStorage(cmsPages, pageId: string) {
        if (cmsPages)
            return JSON.parse(
                cmsPages.flow.pages.find((page) => page.id === pageId)
                    ? "true"
                    : "false"
            );
        return false;
    }

    public getPages(pageId?: string): Observable<any> {
        const storagePages = this.getAndSetStoragePages();
        if (storagePages && this.haveInStorage(storagePages, pageId))
            return of(storagePages);

        let pagesURL = `${this.url}/shallow/@shallow_id`;
        pagesURL = pagesURL.replace("@shallow_id", this.shallowId);
        return this.https.get(pagesURL, this.httpOptions()).pipe(retry(2));
    }

    public getDetail(stepId: string): Observable<any> {
        let detailsURL = `${this.url}/step/${stepId}`;
        return this.https.get(detailsURL, this.httpOptions()).pipe(retry(2));
    }

    public getPageDetail(pageId) {
        try {
            return this.getPages(pageId).pipe(
                mergeMap((data) => {
                    this.getAndSetStoragePages(data);
                    const pages = data.flow.pages;
                    let pageFound;

                    if (Array.isArray(pages)) {
                        pageFound = pages.find((p) => p.id === pageId);
                    } else {
                        pageFound = pages;
                    }

                    if (typeof pageFound === "undefined") {
                        return this.handleCMSPageError();
                    } else {
                        return this.getDetail(pageFound.steps).pipe(
                            map((data) => {
                                return { step: new CMSStep(data.step) };
                            }),
                            catchError((err) => {
                                return this.handleCMSPageError(err);
                            })
                        );
                    }
                }),
                catchError((err) => {
                    return this.handleCMSPageError(err);
                })
            );
        } catch (err) {
            return this.handleCMSPageError(err);
        }
    }

    handleCMSPageError(error?): Observable<any> {
        return of({ step: false, error: Error("CMS_PAGE_ERROR") });
    }
}
